document.addEventListener('DOMContentLoaded', () => {
    ((doc)=>{
        let myDoc = doc;

        const recomended = myDoc.querySelector('.recommended-slider');
        if (recomended) {
            const recOpts = {
                pagination: false,
                trimSpace: 'move',
                focus    : 'center',
                arrows: false,
                padding: '0rem',
                gap: '4px',
                fixedHeight: '377px',
                fixedWidth: '220px',
                mediaQuery: 'min',
                breakpoints: {
                    576: {
                        gap: '4px',
                        fixedHeight: '300px',
                        fixedWidth: '180px',
                        omitEnd: true,
                    },
                    768: {
                        fixedHeight: '350px',
                        fixedWidth: '258px',
                        arrows: true,
                    },
                    992: {
                        fixedHeight: '450px',
                        gap: '4px',
                    },
                    1200: {
                        padding: '2rem',
                    },
                    1400: {
                        fixedHeight: '440px',
                    },
                },
                classes: {
                    pagination: 'splide__pagination position-relative mt-3', // container
                    page      : 'splide__pagination__page',
                    arrows: 'splide__arrows position-absolute d-flex splide-arrows--top end-0',
                    arrow : 'splide__arrow position-relative bg-transparent border border-black rounded-circle transform-0',
                    prev  : 'splide__arrow--prev your-class-prev start-0',
                    next  : 'splide__arrow--next your-class-next  end-0 ms-2',
                },
            };
            let splide = new Splide(recomended, recOpts);

            splide.mount();

            function video() {
                const videosContainer = myDoc.querySelectorAll('.recommended-slider .splide__slide');
                const isMobile = window.matchMedia('(max-width: 991px)').matches;
                let videoElement = null;

                const createVideo = (videoUrl) => {
                    if (!videoElement) {
                        videoElement = myDoc.createElement('video');
                        videoElement.autoplay = true;
                        videoElement.playsInline = true;
                        videoElement.muted = true;
                        videoElement.loop = true;
                        videoElement.controls = false;
                    }
                    videoElement.src = videoUrl;
                };



                if (isMobile) {
                    splide.on('active', (slide) => {
                        if (slide.slide.dataset.video) {
                            createVideo(slide.slide.dataset.video);
                            slide.slide.querySelector('.media-holder').appendChild(videoElement);
                        }
                    });

                    splide.on('inactive', (slide) => {
                        if (slide.slide.querySelector('.media-holder video')) {
                            slide.slide.querySelector('.media-holder video').remove();
                            videoElement = null;
                        }
                    });
                    // Autoplay video in the first slide when mobile
                    const firstSlide = recomended.querySelector('.splide__slide.is-active');
                    if (firstSlide) {
                        createVideo(firstSlide.dataset.video);
                        firstSlide.querySelector('.media-holder').appendChild(videoElement);
                    }
                } else {
                    videosContainer.forEach((videoSlide) => {
                        videoSlide.addEventListener('mouseenter', (e) => {
                            if (videoSlide.dataset.video) {
                                createVideo(videoSlide.dataset.video);
                                videoSlide.querySelector('.media-holder').appendChild(videoElement);
                            }
                        });

                        videoSlide.addEventListener('mouseleave', (e) => {
                            if (videoSlide.querySelector('.media-holder video')) {
                                videoSlide.querySelector('.media-holder video').remove();
                                videoElement = null;
                            }
                        });
                    });
                }
            }

            video();
        }
    })(document);
})
